import React from 'react';
import { useTheme } from '@mui/material/styles';
import OscillatingDotsLoader from './OscillatingDotsLoader';
import DeloreanLoader from './DeloreanLoader';

interface ThemeLoaderProps {
  width?: number;
  height?: number;
  /** Force a specific loader regardless of theme */
  forceLoader?: 'dots' | 'delorean';
}

/**
 * Theme-aware loader component that switches between:
 * - DeloreanLoader for the retro theme (Back to the Future style)
 * - OscillatingDotsLoader for light/dark themes (modern dots animation)
 * 
 * The retro theme is detected by checking for the green primary color (#00ff00)
 * which is unique to the retro theme.
 */
export default function ThemeLoader({ width, height = 100, forceLoader }: ThemeLoaderProps) {
  const theme = useTheme();
  
  // Check if we're using the retro theme by looking at the primary color
  // The retro theme uniquely uses #00ff00 (neon green) as primary
  const isRetroTheme = theme.palette.primary.main === '#00ff00';

  // Allow forcing a specific loader
  if (forceLoader === 'delorean') {
    return <DeloreanLoader width={width} height={height} />;
  }
  if (forceLoader === 'dots') {
    return <OscillatingDotsLoader width={width} height={height} />;
  }

  // Auto-select based on theme
  if (isRetroTheme) {
    return <DeloreanLoader width={width} height={height} />;
  }

  return <OscillatingDotsLoader width={width} height={height} />;
}
